import { useParams } from 'react-router';

import { useGetMainPageQuery, useGetReviewsQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainReviewsPageComponent } from './MainReviewsPageComponent';

export const MainReviewsPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: reviewsData,
    isLoading: areReviewsLoading,
    isFetching: areReviewsFetching,
    isError: isReviewsFetchError,
  } = useGetReviewsQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading || areReviewsLoading}
      isError={isReviewsFetchError || isPageDataFetchError}
    >
      {pageData && reviewsData && (
        <MainReviewsPageComponent
          reviewsData={reviewsData}
          areReviewsFetching={areReviewsFetching}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
